import { RootState } from '@/store';
import { ActionContext, ActionTree } from 'vuex';
import { AuthState } from './state';
import {
  AUTHENTICATION_LOGIN,
  AUTHENTICATION_LOGOUT,
  AUTHENTICATION_SET_USER,

} from './types';

export interface Actions<S, R> extends ActionTree<S, R> {
  [AUTHENTICATION_LOGIN]: (context: ActionContext<S, R>, payload: any) => void;
  [AUTHENTICATION_LOGOUT]: (context: ActionContext<S, R>) => void;
}

export const actions: Actions<AuthState, RootState> = {
  async [AUTHENTICATION_LOGIN]({ commit }, payload: AuthState) {
    commit(AUTHENTICATION_SET_USER, {
      username: payload.username,
      isLogged: true,
      accessToken: payload.accessToken,
      // ...(await authApi.login(payload)).data,
      // isLogged: true,
    });
  },
  [AUTHENTICATION_LOGOUT]({ commit }) {
    // MELHORAR AQUI
    commit(AUTHENTICATION_SET_USER, { username: '', email: '', isLogged: false, accessToken: '' });
  },
};
